import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  /* Importing Google Fonts */
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;700&display=swap');

  /* Resetting margins, paddings, etc. */
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  /* Applying the new font */
  body {
    font-family: 'Montserrat', sans-serif;
    background-color: #f4f4f4;
    color: #333;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  h1, h2, h3, h4, h5, h6 {
    font-weight: 600;
    font-family: 'Montserrat', sans-serif; /* Consistent usage of Montserrat for headings */
  }
`;

export default GlobalStyles;
